import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export default function InternalUserConfirmDialog(props: {
  open: boolean;
  makingInternal: boolean; // true = about to make internal, false = about to make external
  target?: 'user' | 'role';
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { open, makingInternal, target = 'user', onConfirm, onCancel } = props;
  const targetLabel = target === 'role' ? 'role' : 'user';

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{makingInternal ? `Make ${targetLabel} Internal?` : `Make ${targetLabel} External?`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {makingInternal
            ? `This will mark this ${targetLabel} as Internal. This may change how assigned users appear across the system.`
            : `This will mark this ${targetLabel} as External. This may change how assigned users appear across the system.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} color='primary' variant='contained' autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
